import { useState, useEffect } from 'react';
import api from '../api/axios';
import PageHeader from '../components/layout/PageHeader';
import ImportDropzone from '../components/import/ImportDropzone';
import ImportProgress from '../components/import/ImportProgress';

export default function Import() {
  const [logs, setLogs] = useState([]);

  const fetchLogs = () => {
    api.get('/stats').then(res => setLogs(res.data.recentImports || [])).catch(() => {});
  };

  useEffect(() => { fetchLogs(); }, []);

  return (
    <div>
      <PageHeader title="Import Data" subtitle="Upload .html or .json files to import registrations" />
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 mb-6">
        <ImportDropzone onImportComplete={fetchLogs} />
      </div>
      <ImportProgress logs={logs} />
    </div>
  );
}
